/** @jsxImportSource @emotion/react */
import React, { useContext } from "react";
import Countdown from "./Countdown";
import { styPadding } from "../styles";
import BgImage1 from "../../assets/content-img-1.jpg";
import BgImage2 from "../../assets/content-img-2.jpg";
import { LocaleContext } from "../../context/LocaleContext";

import { stySaveDate, stySaveDateContent } from "./styles";
import { txtSaveTheDateTitle } from "./locales";

const SaveTheDate = () => {
  const { lang } = useContext(LocaleContext);

  return (
    <div css={stySaveDate}>
      <div
        css={[
          stySaveDateContent({
            position: "20%",
            bgImage: BgImage1,
            height: "40%",
          }),
          styPadding("20px"),
        ]}
      />
      <div
        css={[
          stySaveDateContent({ position: "50%" }),
          styPadding("20px"),
          { minHeight: "170px", zIndex: 1, position: "relative" },
        ]}
      >
        <div
          css={[
            {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
            },
          ]}
        >
          <h4>{txtSaveTheDateTitle[lang]}</h4>
          <p>26 &#x2022; 08 &#x2022; 2023</p>
          <Countdown targetDate="2023-08-26T16:30:00" lang={lang} />
        </div>
      </div>

      <div
        css={[
          stySaveDateContent({
            position: "80%",
            bgImage: BgImage2,
            height: "40%",
          }),
          styPadding("20px"),
        ]}
      />
    </div>
  );
};

export default SaveTheDate;
